export default __webpack_public_path__ + "static/logo-50f99c3cd768efde4515ba4b6f6da15e.png";